module.exports = __webpack_public_path__ + "img/video.fc1c4425.svg";